/**
 * Tab Pattern 1
 */

document.addEventListener('DOMContentLoaded', () => {
    const tabBlocks = document.querySelectorAll('.tab-pattern-1-block');

    // Settings: Easily adjustable defaults
    const tabSettings = {
        animationReset: true,    // Reset CSS animation on tab switch
        activeClass: 'active',   // Class added to active button/pane
    };

    tabBlocks.forEach(block => {
        // Grab navigation buttons and content panes within this block
        const navButtons = block.querySelectorAll('.tabs-navigation .tab-btn');
        const tabPanes  = block.querySelectorAll('.foxtrot-tab-content .foxtrot-tab-pane');

        if (!navButtons.length || !tabPanes.length) return; // Fail-safe

        // Function to switch tabs
        const switchTab = (index) => {
            navButtons.forEach((btn, i) => {
                btn.classList.toggle(tabSettings.activeClass, i === index);
            });

            tabPanes.forEach((pane, i) => {
                const isActive = i === index;
                pane.classList.toggle(tabSettings.activeClass, isActive);

                // Optionally reset CSS animations
                if (tabSettings.animationReset && isActive) {
                    pane.style.animation = 'none';
                    void pane.offsetHeight; // Trigger reflow
                    pane.style.animation = '';
                }
            });
        };

        // Add click listeners to buttons
        navButtons.forEach((btn, index) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                switchTab(index);
            });
        });

        // Initialize first tab
        switchTab(0);
    });


    /**
     * ===============================================================
     * SCROLL OPACITY ANIMATION
     * Applies 'is-in-view' class to items when visible
     * ===============================================================
     */

    const opacityContainers = document.querySelectorAll('.scroll-opacity-animation');

    if (opacityContainers.length > 0) {
        const observerOptions = {
            root: null,                         // Use viewport as root
            rootMargin: '-15% 0px -18% 0px',    // Adjust fade-in/out trigger
            threshold: 0.1,                     // Trigger when 10% visible
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                entry.target.classList.toggle('is-in-view', entry.isIntersecting);
            });
        }, observerOptions);

        // Observe only the intended content items inside each container
        opacityContainers.forEach(container => {
            const items = container.querySelectorAll('.foxtrot-content-item');
            items.forEach(item => observer.observe(item));
        });
    }
});